import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { ColumnLayout } from "@/components/Layout/ColumnLayout";
import { GiftGlobalSettings } from "@/components/Product/Gift/GiftGlobalSettings";
import { Page } from "@/pages/Page";

export const GiftGlobalSettingsPage = () => {
    const history = useHistory();

    const handleGiftsClick = () => {
        history.push("/products/giftOffers");
    };

    return (
        <Page title="Gift Global Settings">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Products</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleGiftsClick}>Gifts</Breadcrumb.Item>
                        <Breadcrumb.Item>Global Settings</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <GiftGlobalSettings />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
